import { useMemo } from 'react'

import { VerifierRequirements } from '@frame/lib/api/client-session/types'
import { VerifierType } from '@frame/lib/api/common/types'
import { useStrategies } from '@frame/lib/hooks/useStrategies'
import { useStore } from '@frame/lib/stores/useStore'

export default function useChosenVerifierRequirements(): VerifierRequirements {
  const { verifierRequirements, verifierType } = useStore(({ session }) => ({
    verifierRequirements: session?.configuration.settings?.verifier_requirements ?? undefined,
    verifierType: session?.verifier_type ?? undefined,
  }))
  const { documentsEnabled, bankEnabled } = useStrategies()
  const isTenantVerifier = verifierType === VerifierType.TENANT

  return useMemo(() => {
    if (verifierRequirements !== undefined) {
      return verifierRequirements
    }

    if (bankEnabled && isTenantVerifier) {
      return VerifierRequirements.INCOME_CURRENT
    }

    // Legacy logic
    if (documentsEnabled) {
      return VerifierRequirements.INCOME_CURRENT
    }
    return VerifierRequirements.EMPLOYMENT_3_YEARS
  }, [verifierRequirements, bankEnabled, isTenantVerifier, documentsEnabled])
}
